module.exports = __webpack_public_path__ + "9e5fbe6ca180ec1e48b9f24e04c71134.png";